import { turboproApiLista } from '@/api/turbopro';
import type { EventoNfse } from '../types';

/**
 * Os eventos da NFS-e (`MANFSEVE`), os mais recentes primeiro: a seção de eventos do detalhe (SPEC-011, T7 e T9).
 * Lista vazia é nota sem evento; nota que não é do gestor vira erro, com a mensagem da API.
 */
export async function fetchEventosNfse(chaveAcessoDoc: string): Promise<EventoNfse[]> {
  const { data } = await turboproApiLista<EventoNfse>(
    `Documento/EventosNFS/${encodeURIComponent(chaveAcessoDoc)}`
  );
  return data ?? [];
}
